import { SET_RETURN_POLICY_CONTENT } from "actions/types";

let initialState = {
  returnPolicyContent: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_RETURN_POLICY_CONTENT: {
      return {
        ...state,
        returnPolicyContent: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
